import {fetchDeliveryInstruction} from '@web/actions/deliveryInfo'
import {EntryMethod} from '@web/core/constants'
import makeSlice from '@web/slices/deliveryInfo/sliceMaker'

const slice = makeSlice({
    extraReducers(builder) {
        builder.addCase(fetchDeliveryInstruction.fulfilled, (state, {payload: {deliveryInstruction}}) => {
            if (deliveryInstruction) {
                state.pickup = {
                    location: {
                        type: deliveryInstruction.locationCode,
                        content: deliveryInstruction.locationDescription ?? '',
                    },
                    entryMethod: {
                        type: deliveryInstruction.entranceCode ?? EntryMethod.LOBBY_PW,
                        content: deliveryInstruction.entranceDescription ?? '',
                    },
                    alwaysUses: true,
                }
            }
        })
    },
})

export default slice.reducer
export const actions = slice.actions
